import { render, staticRenderFns } from "./AsignarRolUsuario.vue?vue&type=template&id=7a33698b&"
import script from "./AsignarRolUsuario.vue?vue&type=script&lang=js&"
export * from "./AsignarRolUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports